import React, { useContext, useEffect, useState } from "react";
import './App.css';
import { patchDomainSettings } from "utils/api";
import { AuthContext } from "contexts/AuthContext";

export default function Modal({ setChatBoxSettings, chatBoxSettings }) {
    const { handleError, state, fetchProfile } = useContext(AuthContext);
    const [showModal, setShowModal] = useState(false);

    const openai_keys = state.profile?.domain?.settings?.openai_keys || {};
    const val = Object.values(openai_keys)?.length ? Object.values(openai_keys)[0] : '';

    const [apiVariables, setApiVariables] = useState({ OPENAI_API_KEY: val });

    useEffect(() => {
        setApiVariables({ OPENAI_API_KEY: val });
        localStorage.setItem('apiVariables', JSON.stringify(apiVariables));
    }, [showModal, state]);

    const handleSaveChanges = async () => {
        setChatBoxSettings(chatBoxSettings);

        try {
            await patchDomainSettings({ key: apiVariables.OPENAI_API_KEY });
            localStorage.setItem('apiVariables', JSON.stringify(apiVariables));
            await fetchProfile();
        } catch (err) {
            handleError(err);
        }

        setShowModal(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setApiVariables(prevState => ({
            ...prevState,
            [name]: value
        }));
        localStorage.setItem('apiVariables', JSON.stringify({
            ...apiVariables,
            [name]: value
        }));
    };

    return (
        <div className="settings">
            <button
                style={{ background: '#6EB5D2' }}
                className="bg-cyan-500 text-white active:bg-cyan-600 font-bold text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                type="button"
                onClick={() => setShowModal(true)}
            >
                OpenAI API Key
            </button>
            {showModal ? (
                <>
                    <div
                        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                    >
                        <div className="relative w-auto my-6 mx-auto max-w-3xl">
                            <div
                                className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                <div className="relative p-4 flex-auto">
                                    <main className="" id="form">
                                        <form className="report_settings">
                                            <div className="form-group text-gray-800 font-bold mb-0">
                                                <label className="form-group-label">OPENAI_API_KEY</label>
                                                <input type="text" name="OPENAI_API_KEY"
                                                       value={apiVariables.OPENAI_API_KEY}
                                                       onChange={handleInputChange}/>
                                            </div>
                                        </form>
                                    </main>
                                </div>
                                <div className="flex items-center justify-between p-3">
                                    <button
                                        className="bg-gray-200 active:bg-gray-300 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={() => setShowModal(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        style={{backgroundColor: '#6EB5D2'}}
                                        className="text-white font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                        type="button"
                                        onClick={handleSaveChanges}
                                    >
                                        Save & Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            ) : null}
        </div>
    );
}
